<template>
  <section id="app-location">
    <div class="bg-app-location">
      <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    
    <!-- Botón toggle panel (solo desktop) -->
    <button
      class="panel-toggle d-none d-md-flex"
      @click="isPanelOpen = !isPanelOpen"
      :aria-expanded="isPanelOpen.toString()"
      aria-controls="control-panel-desktop"
      :title="isPanelOpen ? 'Cerrar panel' : 'Abrir panel'"
      :style="isPanelOpen ? { left: '366px' } : {}"
    >
      <i :class="isPanelOpen ? 'bi bi-x-lg' : 'bi bi-list'"></i>
    </button>

    <!-- Panel de control (izquierda en desktop, arriba en móvil) -->
    <div class="control-panel" id="control-panel-desktop" v-show="isPanelOpen">
      <div class="header-form">
        <img src="@/assets/images/logo-alcaldia-acacias.png" alt="" width="150px">
        <span class="tag-acacias">#RecuperandoAcacias</span>
      </div>
      
      <div class="panel-content">
        <h1>¡Conéctate a más de <span>+{{ this.locations.length }}</span> puntos Wi-Fi gratis en Acacias - Meta!</h1>
        
        <div class="description-app mt-md-5 mt-1 d-none d-md-block">
          <p class="helper-description">
            Ingresa tu ubicación (Barrio, Carrera - Calle) y haz clic en "Buscar". Te mostraremos el punto Wi-Fi más cercano en el mapa y te guiaremos hasta allí 👇🏼 Pero espera, ¡hay más! 🚀 Si prefieres explorar, simplemente toca el punto Wi-Fi que te llame la atención en el mapa y traza la ruta con un solo clic en "¿Cómo llegar?" ¿Quieres descubrir el punto Wi-Fi más cercano a tu ubicación? ¡No hay problema! Simplemente dale clic al botón "Buscar el punto Wi-Fi más cercano". ¡Explora y conéctate en un instante! 🌐
          </p>
        </div>

        <!-- Sección de búsqueda -->
        <div class="search-section">
          <div class="nearest-wifi">
            <label class="fw-bold mb-0">Punto Wi-Fi más cercano 👇🏼</label>
            <button class="btn-search my-1" @click="markNearestRoute">
              Buscar el punto Wi-Fi más cercano 
            </button>
          </div>

          <div class="address-search">
            <label class="fw-bold mb-2 mt-3">Ingresa tu dirección</label>
            <div :class="['custom-select1', { open: isOpen }]">
              <div class="custom-options">
                <div class="search-locations">
                  <i class="bi bi-search"></i>
                  <input 
                    type="text" 
                    placeholder="Ingresa tu dirección aquí." 
                    class="form-control"
                    v-model="search"
                    @keyup.enter="findLocation"
                    @input="validate">
                </div>
              </div>
            </div>

            <div v-if="errorMessage" class="error-message mt-4 text-danger fs-6">
              {{ errorMessage }}
            </div>
            
            <div class="action-buttons">
              <button 
                class="btn-search"
                :disabled="!isSearchValid" 
                @click="findLocation"
                :class="{ 'disabled-button': !isSearchValid }">
                Buscar
              </button>

              <button class="btn-resert" @click="resetMapAndClearSearch">
                Reiniciar
              </button>
            </div>
          </div>
          
          <div class="helper-text d-none d-md-block text-center mt-4">
            <span class="helper-notfound-zona">
              <b>¿No encuentras tu zona wifi?</b> Por favor, escríbenos 
              <a href="https://www.facebook.com/AcaciasDigital" target="_blank">aquí</a> <br> 
              #RecuperandoAcacias
            </span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Mapa (ocupará el resto del espacio) -->
    <div class="map-container">
      <div @click="resetMapAndClearSearch" class="reiniciar-mapa d-block d-md-none">
        <i class="bi bi-arrow-clockwise"></i>
      </div>
      <div id="map"></div>
    </div>

    <!-- Barra de búsqueda flotante (solo móvil) -->
    <div class="mobile-search-bar d-flex d-md-none">
      <i class="bi bi-search"></i>
      <input
        type="text"
        placeholder="Buscar dirección..."
        class="mobile-search-input"
        v-model="search"
        @keyup.enter="findLocation"
        @input="validate">
      <button class="mobile-search-btn" :disabled="!isSearchValid" @click="findLocation">
        <i class="bi bi-arrow-right-circle-fill"></i>
      </button>
    </div>
    <div v-if="errorMessage" class="mobile-search-error d-block d-md-none">
      {{ errorMessage }}
    </div>

    <!-- FAB — Wi-Fi más cercano (solo móvil) -->
    <button class="fab-nearest d-flex d-md-none" @click="markNearestRoute">
      <i class="bi bi-wifi"></i>
      Wi-Fi cercano
    </button>

<!-- Modal para Zonas WiFi -->
<div v-if="showModal" class="modal-backdrop" @click.self="closeModal">
  <div class="modal-container">
    <button class="modal-close" @click="closeModal">&times;</button>
    
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ currentModalLocation.title }}</h3>
      </div>

      <div v-if="currentModalLocation.images && currentModalLocation.images.length" class="slider-container">
        <img
          :src="currentModalLocation.images[currentImageIndex]"
          alt="Zona WiFi"
          class="modal-image"
          @error="onImageError"
        >

        <button
          v-if="currentModalLocation.images.length > 1"
          class="slider-arrow left"
          @click="prevImage"
        >
          &#10094;
        </button>

        <button
          v-if="currentModalLocation.images.length > 1"
          class="slider-arrow right"
          @click="nextImage"
        >
          &#10095;
        </button>
      </div>

      <div class="modal-body">
        <p v-if="currentModalLocation.dir">
          <strong>📍 Dirección:</strong><br>
          {{ currentModalLocation.dir }}
        </p>

        <div
          v-if="currentModalLocation.estado || currentModalLocation.conexion || currentModalLocation.ssid || currentModalLocation.radio_cobertura"
          class="modal-details"
        >
          <hr class="modal-divider">
          <p class="modal-details-title">Detalles técnicos</p>

          <div v-if="currentModalLocation.conexion" class="modal-detail-row">
            <span class="modal-detail-icon">🔌</span>
            <span class="modal-detail-label">Conexión</span>
            <span class="modal-detail-value">{{ currentModalLocation.conexion }}</span>
          </div>

          <div v-if="currentModalLocation.ssid" class="modal-detail-row">
            <span class="modal-detail-icon">📶</span>
            <span class="modal-detail-label">SSID</span>
            <span class="modal-detail-value">{{ currentModalLocation.ssid }}</span>
          </div>

          <div v-if="currentModalLocation.radio_cobertura" class="modal-detail-row">
            <span class="modal-detail-icon">📡</span>
            <span class="modal-detail-label">Cobertura</span>
            <span class="modal-detail-value">{{ currentModalLocation.radio_cobertura }}</span>
          </div>

          <div v-if="currentModalLocation.estado" class="modal-detail-row">
            <span class="modal-detail-icon">🏷️</span>
            <span class="modal-detail-label">Estado</span>
            <span
              class="modal-estado-badge"
              :class="currentModalLocation.estado === 'Nueva' ? 'badge-nueva' : 'badge-antigua'"
            >
              {{ currentModalLocation.estado }}
            </span>
          </div>
        </div>

        <button
          class="btn-route"
          @click="showRouteFromModal"
          :disabled="!currentLocationAvailable">
          ¿Cómo llegar?
        </button>

        <p v-if="!currentLocationAvailable" class="geo-warning">
          Active la geolocalización para ver rutas
        </p>
      </div>
    </div>
  </div>
</div>

  </section>
</template>

<style>
@import "@/assets/css/app-location.css";
</style>

<script>
/* global google */
import axios from "axios";
import { GOOGLE_MAPS_API_KEY } from "@/config";
import marker_here_ico from "@/assets/images/marker_here.png";
import { loadLocations } from "@/services/wifiLocations";

export default {
  data() {
    return {
      isPanelOpen: false,
      showModal: false,
      // currentModalLocation: null,
      currentModalLocation: {},
      currentImageIndex: 0,

      address: "",
      map: null,
      infoWindow: null,
      currentMarker: null,
      directionsService: null,
      directionsRenderer: null,
      currentLocationAvailable: false,
      directionsRenderers: [],
      routeColors: ["#FF0000", "#0000FF"],
      locations: [],
      markers: [],
      allMarkers: [],
      search: "",
      errorMessage: "",
      isSearchValid: false,
    };
  },
  async mounted() {
    this.locations = await loadLocations();
    this.isPanelOpen = window.innerWidth >= 768;
    this.initMap();
    document.addEventListener('click', this.handleClickOutside);
    // Solicitar la ubicación actual tan pronto como se monte el componente
    this.getCurrentLocation();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    initMap() {
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: { lat: 3.9916843, lng: -73.7764501 },
      zoom: 15,
    });
    this.infoWindow = new google.maps.InfoWindow();
    this.directionsService = new google.maps.DirectionsService();
    // Inicializar directionsRenderer aquí
    this.directionsRenderer = new google.maps.DirectionsRenderer();
    this.directionsRenderer.setMap(this.map); // Asignar el mapa al directionsRenderer
    this.addMarkers();
  },

    addMarkers() {
    this.markers.forEach(m => m.setMap(null));
    this.markers = [];
    this.locations.forEach((location) => {
      const marker = new google.maps.Marker({
        position: { lat: location.lat, lng: location.lng },
        map: this.map,
        title: location.title,
        icon: {
          url: location.icon,
          scaledSize: new google.maps.Size(48, 48),
          anchor: new google.maps.Point(24, 24),
        },
      });
      
      marker.addListener("click", () => {
        this.handleLocationClick(location, marker);
      });
      
      this.markers.push(marker);
    });
  },
    resetMapAndClearSearch() {
      this.initMap();
      this.search = "";
      this.errorMessage = ""; // Limpia mensajes de error
      this.isSearchValid = false; // Desactiva el botón de búsqueda
      // this.resetMap();
    },
    resetMap() {
      const mapElement = document.getElementById("map");
      while (mapElement.firstChild) {
        mapElement.removeChild(mapElement.firstChild);
      }
      this.map = new google.maps.Map(mapElement, {
        center: { lat: 3.9916843, lng: -73.7764501 },
        zoom: 15,
      });
      this.infoWindow = new google.maps.InfoWindow();
      this.directionsRenderers = [];
    },
    findLocation() {
      const fullAddress = `${this.search}, Acacias Meta Colombia`;
      axios
        .get(`https://maps.googleapis.com/maps/api/geocode/json`, {
          params: {
            address: fullAddress,
            key: GOOGLE_MAPS_API_KEY,
          },
        })
        .then((response) => {
          if (response.data.status === "OK" && response.data.results.length > 0) {
            const location = response.data.results[0].geometry.location;
            this.resetMap();
            this.map.setCenter(location);
            this.map.setZoom(15);
            this.addCurrentLocationMarker(location);
            this.findClosestLocations(location);
          } else {
            alert("No se encontraron resultados para la dirección ingresada.");
          }
        })
        .catch((error) => {
          console.error("Error durante la geocodificación:", error);
          alert("Geocodificación fallida: " + error.message);
        });
    },
    addCurrentLocationMarker(location) {
      if (this.currentMarker) {
        this.currentMarker.setMap(null);
      }
      this.currentMarker = new google.maps.Marker({
        position: location,
        map: this.map,
        icon: {
          url: marker_here_ico,
          scaledSize: new google.maps.Size(48, 48),
          anchor: new google.maps.Point(24, 24),
        },
      });
      this.markers.push(this.currentMarker);
      this.infoWindow.setContent("<div style='width: 105px;'><strong>Estás aquí</strong></div>");
      this.infoWindow.open(this.map, this.currentMarker);
    },
    findClosestLocations(location) {
    if (!google.maps.geometry) {
      console.error("La biblioteca de geometría no está disponible.");
      alert("La biblioteca de geometría no está disponible.");
      return;
    }
    
    const distances = this.locations.map((loc) => ({
      ...loc,
      distance: google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(location.lat, location.lng),
        new google.maps.LatLng(loc.lat, loc.lng)
      ),
    }));
    
    const closestLocations = distances
      .sort((a, b) => a.distance - b.distance)
      .slice(0, 2);
      
    closestLocations.forEach((location) => {
      const marker = new google.maps.Marker({
        position: { lat: location.lat, lng: location.lng },
        map: this.map,
        title: location.title,
        icon: {
          url: location.icon,
          scaledSize: new google.maps.Size(48, 48),
          anchor: new google.maps.Point(24, 24),
        },
      });
      
      marker.addListener("click", () => {
        this.handleLocationClick(location, marker);
      });
      
      this.markers.push(marker);
    });
    
    this.plotRoutes(location, closestLocations);
  },
handleLocationClick(location) {
    this.currentModalLocation = location;
    this.currentImageIndex = 0; // 👈 Reiniciar índice al abrir nuevo modal
    this.showModal = true;

    // Esperar a que Vue inserte el elemento en el DOM antes de activar la animación
    this.$nextTick(() => {
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) backdrop.classList.add('active');
    });
  },

  showRouteFromModal() {
    if (this.currentModalLocation && this.currentLocationAvailable) {
      this.showRoute(this.currentModalLocation.lat, this.currentModalLocation.lng);
      this.closeModal();
    } else {
      alert("Por favor active la geolocalización para usar esta función");
    }
  },

  closeModal() {
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) backdrop.classList.remove('active');
    setTimeout(() => {
      this.showModal = false;
      this.currentModalLocation = {};
      this.currentImageIndex = 0;
    }, 300); // Esperar a que termine la animación
  },

  nextImage() {
    if (!this.currentModalLocation.images) return;
    this.currentImageIndex = 
      (this.currentImageIndex + 1) % this.currentModalLocation.images.length;
  },
  prevImage() {
    if (!this.currentModalLocation.images) return;
    this.currentImageIndex =
      (this.currentImageIndex - 1 + this.currentModalLocation.images.length) %
      this.currentModalLocation.images.length;
  },
  onImageError() {
    if (!this.currentModalLocation.images) return;
    this.currentModalLocation.images.splice(this.currentImageIndex, 1);
    if (this.currentImageIndex >= this.currentModalLocation.images.length) {
      this.currentImageIndex = 0;
    }
  },

    plotRoutes(origin, destinations) {
      destinations.forEach((destination, index) => {
        const request = {
          origin: new google.maps.LatLng(origin.lat, origin.lng),
          destination: new google.maps.LatLng(destination.lat, destination.lng),
          travelMode: "DRIVING",
        };
        this.directionsService.route(request, (result, status) => {
          if (status === "OK") {
            const renderer = new google.maps.DirectionsRenderer({
              map: this.map,
              polylineOptions: {
                strokeColor: this.routeColors[index % this.routeColors.length],
                strokeWeight: 5,
              },
            });
            renderer.setDirections(result);
            this.directionsRenderers.push(renderer);
          } else {
            console.error("Error al trazar la ruta:", status);
            alert("Error al trazar la ruta: " + status);
          }
        });
      });
    },
    showRoute(destinationLat, destinationLng) {
      this.resetMapAndClearSearch();
      if (this.currentMarker) {
        const origin = this.currentMarker.getPosition();
        const destination = new google.maps.LatLng(destinationLat, destinationLng);
        const request = {
          origin: origin,
          destination: destination,
          travelMode: google.maps.TravelMode.DRIVING,
        };
        this.directionsService.route(request, (result, status) => {
          if (status === google.maps.DirectionsStatus.OK) {
            // Colorear la ruta de verde
            this.directionsRenderer.setDirections(result);
            this.directionsRenderer.setOptions({ polylineOptions: { strokeColor: 'red' } });

            // Mostrar el pop-up en la ubicación actual
            this.infoWindow.setContent("<div style='width: 105px;'><strong>Estás aquí</strong></div>");
            this.infoWindow.open(this.map, this.currentMarker);
          } else {
            console.error("Error al trazar la ruta:", status);
            alert("Error al trazar la ruta: " + status);
          }
        });
      } else {
        alert("No se ha determinado la ubicación actual.");
      }
    },
    validate() {
      if (!this.search) {
        this.errorMessage = "Debes agregar una dirección";
        this.isSearchValid = false;
      } else {
        this.errorMessage = "";
        this.isSearchValid = true;
      }
    },
    markNearestRoute() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const location = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.resetMap();
            this.map.setCenter(location);
            this.map.setZoom(15);
            this.addCurrentLocationMarker(location);
            this.findClosestLocations(location);
            // Habilitar la ubicación actual
            this.currentLocationAvailable = true;
          },
          (error) => {
            console.error("Error al obtener la ubicación del usuario:", error);
            alert("No se pudo obtener la ubicación del usuario.");
          }
        );
      } else {
        console.error("El navegador no soporta la geolocalización.");
        alert("El navegador no soporta la geolocalización.");
      }
    },

    getCurrentLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const location = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            this.currentMarker = new google.maps.Marker({
              position: location,
              map: this.map,
              icon: {
                url: marker_here_ico,
                scaledSize: new google.maps.Size(48, 48),
                anchor: new google.maps.Point(24, 24),
              },
            });
            // Habilitar la ubicación actual
            this.currentLocationAvailable = true;
            
          },
          (error) => {
            console.error("Error al obtener la ubicación del usuario:", error);
            alert("No se pudo obtener la ubicación del usuario.");
          }
        );
      } else {
        console.error("El navegador no soporta la geolocalización.");
        alert("El navegador no soporta la geolocalización.");
      }
    },
  }
};
</script>